import React, { useRef } from "react";
import styles from "./styles.module.css";
import clsx from "clsx";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { NAVIGATION_ROUTES } from "../../constant";
interface CountdownProps {
  millisecondsleft: number;
  label: string;
  gameName: string;
  ltid: number;
}

export const convertMillisecondsToTime = (milliseconds: number) => {
  // Convert milliseconds to seconds
  let seconds = Math.floor(milliseconds / 1000);

  // Calculate days, hours, minutes, and remaining seconds
  const days = Math.floor(seconds / 86400); // 86400 seconds in a day
  seconds %= 86400;
  const hours = Math.floor(seconds / 3600); // 3600 seconds in an hour
  seconds %= 3600;
  const minutes = Math.floor(seconds / 60); // 60 seconds in a minute
  seconds %= 60;

  return {
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds,
  };
};

export const getTimerString = (
  countdown: number,
  shouldSliceToThreeUnits: boolean = false
) => {
  const { days, hours, minutes, seconds } =
    convertMillisecondsToTime(countdown);
  const countdownLengthWithThreeUnits = 11;
  const lastOneUnitlength = 4;
  let result = "";
  if (days > 0) {
    result += (days < 10 ? `0${days}` : days) + "d";
  }
  if (hours > 0) {
    result +=
      (result !== "" ? ":" : "") + (hours < 10 ? `0${hours}` : hours) + "h";
  }
  if (minutes > 0) {
    result +=
      (result !== "" ? ":" : "") +
      (minutes < 10 ? `0${minutes}` : minutes) +
      "m";
  }
  if (seconds > 0) {
    result +=
      (result !== "" ? ":" : "") +
      (seconds < 10 ? `0${seconds}` : seconds) +
      "s";
  }
  if (
    shouldSliceToThreeUnits &&
    result.length > countdownLengthWithThreeUnits
  ) {
    result = result.slice(0, -lastOneUnitlength);
  }
  return result.trim();
};

export const Countdown: React.FC<CountdownProps> = ({
  millisecondsleft,
  gameName,
  ltid,
  label,
}) => {
  const [timeleft, settimeleft] = useState(millisecondsleft);
  const myInterval = useRef<NodeJS.Timeout | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    myInterval.current = setInterval(() => {
      settimeleft((timeleft) => Math.max(timeleft - 1000, 0));
    }, 1000);
    return () => {
      if (myInterval.current) {
        clearInterval(myInterval.current);
      }
    };
  }, []);

  useEffect(() => {
    if (timeleft <= 0 && myInterval?.current) {
      clearInterval(myInterval?.current);
    }
  }, [timeleft]);

  if (timeleft <= 0) {
    navigate(`${NAVIGATION_ROUTES.TOURNAMENTDETAILS}/leaderboard?gameName=${gameName}&ltid=${ltid}`);
    return null;
    //  null
  }
  return (
    <div className={styles.countdowncontainer}>
      <p className={clsx(styles.label, "fontWeightMedium  fontSizeSm14")}>
        {label}
      </p>
      <p className={clsx(styles.timeDisplay, "fontWeightBolder fontSizeMd")}>
        {getTimerString(timeleft)}
      </p>
    </div>
  );
};
